import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getSocialClubPdf } from "../../../api/general";

const Bar = () => {
  const { setAddSocialClubClick, setSocialClubInputValue, socialClubInputValue } =
    useContext(StoreContext);

  const getSocialClubPdfMethod = async () => {
    const response = await getSocialClubPdf();
    if (response.error) {
      console.log("Sosyal Kulüp pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Sosyal Kulüp pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.socialClubs}>
        <div className={style.socialClubstext}>Sosyal Kulüpler</div>
        <Link>
          <img alt="" className={style.socialClubsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setSocialClubInputValue(e.target.value);
          }}
          value={socialClubInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddSocialClubClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Kulüp</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getSocialClubPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
